import axiosInstance from "../Api/AxiosInstance";
import { redirectHomeOnForbidden } from "./AdminAccessDeniedHelper";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getCurrentFiscalYearDetails = async (token: any) => {
    try {

        const response = await axiosInstance.get(`${API_BASE_URL}/CurrentFiscalYearDetails`);

        return response.data;
    }
    catch (error) {
        console.error('Error fetching Current FiscalYear Details:', error);
        throw error;
    }
};

export const getFiscalYearList = async () => {
    try {

        const response = await axiosInstance.get(`${API_BASE_URL}/FiscalYearList`);

        return response.data;
    }
    catch (error) {
        redirectHomeOnForbidden(error);
        console.error('Error fetching FiscalYear List:', error);
        throw error;
    }
};
